import { render, staticRenderFns } from "./DepartmentModule.vue?vue&type=template&id=42305060&"
import script from "./DepartmentModule.vue?vue&type=script&lang=js&"
export * from "./DepartmentModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports